import { render, staticRenderFns } from "./fieldsBlockPalletSelect.vue?vue&type=template&id=d73048b0&lang=pug"
import script from "./fieldsBlockPalletSelect.vue?vue&type=script&lang=js"
export * from "./fieldsBlockPalletSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports